<template>
  <div id="app"
    class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
    <HeadNav selectedLanguage="en" page="privacy" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <article id="post-3" class="post-3 page type-page status-publish">
              <div class="inside-article">
                <header class="entry-header section-content" aria-label="Content">
                  <h1 class="entry-title" itemprop="headline">
                    Privacy Policy
                  </h1>
                </header>

                <div class="section-content" itemprop="text">
                  <p>
                    At <a href="https://gbmodshub.com" class="jump-url">gbmodshub.com</a>, your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your information when you visit or interact with our website.
                  </p>
                  <ol>
                    <li>
                       Information We Collect <br>
                       We may collect the following types of information:
                       <ul>
                        <li> <strong>Personal Information</strong>: such as your name or email address when you contact us directly.</li>
                        <li> <strong>Non-Personal Information</strong>: including browser type, operating system, referring URLs, and IP address for analytics purposes.</li>
                       </ul>
                    </li>
                    <li>
                      How We Use Your Information <br>
                      We use the collected information to: 
                      <ul>
                        <li> Respond to your inquiries or support requests.</li>
                        <li> Improve website performance and user experience.</li>
                        <li> Monitor site usage and detect any technical issues.</li>
                      </ul>
                    </li>
                    <li> 
                       Cookies <br>
                       We may use cookies to store user preferences, analyze site traffic, and enhance the user experience. You can choose to disable cookies through your browser settings.
                    </li>
                    <li>
                       Third-Party Links   <br>
                       Our website may contain links to external sites. We are not responsible for the privacy practices or content of those third-party websites. Please review their respective privacy policies before sharing your information.
                    </li>
                    <li>
                       Data Security   <br>
                       While we implement reasonable security measures to protect your data, please understand that no method of transmission over the internet is 100% secure.
                    </li>
                    <li>
                       Children’s Privacy <br>
                       Our content is not directed toward children under the age of 13. We do not knowingly collect personal information from children.
                    </li>
                    <li>
                      Consent <br>
                      By using <strong>gbmodshub.com</strong>, you consent to our Privacy Policy and agree to its terms.
                    </li>
                    <li>
                      Changes to This Policy <br>
                      We may update this Privacy Policy at any time. Any changes will be posted on this page with an updated effective date.
                    </li>
                  </ol>
                </div>
                <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'privacy',

      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },

  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100%!default;
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
